export default __webpack_public_path__ + "images/AY.359cefa.png";